<template>
  <div class="content">
    <div class="preview" @click="changePdfPage(0)" v-if="this.currentPage > 1">上一页</div>
    <div class="next" @click="changePdfPage(1)" v-if="this.currentPage !== this.pageCount">下一页</div>
    <div class="download" @click="download()" v-if="disableDownLoad == false">点击下载</div>
    <div v-if="!flag" class="load"> Loading...</div>
    <div class="pdf" v-show="fileType === 'pdf'">
      <pdf
        :src="DownLoadUrl" 
        :page="currentPage" 
        @num-pages="pageCount=$event" 
        @page-loaded="currentPage=$event" 
        @loaded="loadPdfHandler"> 
      </pdf>
    </div>
  </div>
</template> 
<script type="text/javascript" src="../../public/uni.webview.1.5.2.js"></script>
<script>
import pdf from 'vue-pdf'
import MobileDetect from 'mobile-detect';
  export default { 
    components: {pdf}, 
    data () {
      return {
        currentPage: 0, // pdf文件页码
        pageCount: 0, // pdf文件总页数
        fileType: 'pdf', // 文件类型
        flag: false,
        DownLoadUrl:'', 
        disableDownLoad: false,
        isIOS: false,
        appPlus: false 
      }
    },
    created(){
      // 判断手机系统是IOS还是Android 
        let device_type = navigator.userAgent; //获取userAgent信息
        let md = new MobileDetect(device_type); //初始化mobile-detect
        let os = md.os(); //获取系统
        if(os === 'iOS'){
          this.isIOS = true; 
        }
      // 有时PDF文件地址会出现跨域的情况,这里最好处理一下
      // this.DownLoadUrl = pdf.createLoadingTask(this.DownLoadUrl);

    },
	mounted() {
		let _this = this;
		this.$nextTick(() => {
			// 初始化uni.webview
			document.addEventListener("UniAppJSBridgeReady", function() {
				uni.getEnv(function(res) {
					if (res.plus) {
						_this.appPlus = true;
					} else {
						_this.appPlus = false;
					}
				});
				_this.getUrlKey()
			});
		});
	},
    methods: {
      // 改变PDF页码,val传过来区分上一页下一页的值,0上一页,1下一页
      changePdfPage (val) { 
        if (val === 0 && this.currentPage > 1) {
          this.currentPage--
        }
        if (val === 1 && this.currentPage < this.pageCount) {
          this.currentPage++
        }
      },

      // pdf加载时
      loadPdfHandler (e) {
        this.currentPage = 1 // 加载的时候先加载第一页
        this.flag = true
      },
      getUrlKey() {
        let URL = location.hash;
        let StringData = URL.split("PreviewPDF?")[1]; //字符分割
        let Obj = {};
        if(StringData !== undefined){
            let Arr= [];
            if(this.isIOS && this.appPlus){
              Arr = decodeURIComponent(StringData).split('&');
            }else{
              Arr= StringData.split('&');
            }
            Arr.forEach(v => {
              Obj[v.split('=')[0]] = v.split("=")[1];
            })
        }
        this.disableDownLoad = Obj.disableDownLoad ? Obj.disableDownLoad : false;
        this.DownLoadUrl = decodeURIComponent(Obj.url);
      },
      download(){
        window.open(this.DownLoadUrl)
      }

    }
  }

</script>
<style>
.next,
.preview{
  position: fixed;
  width:68px;
  height:32px;
  background:rgba(26,179,148,1);
  box-shadow:0px 3px 6px rgba(26,179,148,0.33);
  bottom: 4.8%;
  font-size:12px;
  font-family:SF Pro Text;
  font-weight:500;
  line-height:32px;
  z-index: 999;
  text-align: center;
  color:rgba(252,255,254,1);
}
.preview{
  left: 0;
  border-radius:0px 16px 16px 0px;
}
.next{
  right: 0;
  border-radius:16px 0px 0px 16px;
}
.download{
  position: fixed;
  font-size:12px;
  height:32px;
  left: 50%;
  line-height: 32px;
  text-align: center;
  bottom: 4.8%;
  z-index: 999;
  font-weight:500;
  color:rgba(26,179,148,1);
  transform: translateX(-50%)
}
.load{
  width: 100%;
  margin-top: 30%;
  text-align: center
}
</style>